export default "__VITE_ASSET__LQI9CQcV__"